import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-retailer',
    imports: [
        RouterOutlet
    ],
    providers: [
        MessageService
    ],
    templateUrl: './retailer.component.html',
    styleUrl: './retailer.component.scss'
})
export class RetailerComponent {

}
